// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__-RfLS","container":"styles_container__shAON","footer":"styles_footer__0oMMS"};